// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tour-start-button, 
.how-do-i-button{
  display: flex;
  align-items: center;
  gap: 8px;
  color: white;
  border: none;
  padding: 10px 20px;
  font-size: 16px;
  cursor: pointer;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
  transition: all 0.3s ease;
  width:180px;
}

.tour-start-button .material-icons {
  font-size: 20px;
  animation: spin-sparkle 4s linear infinite;
}
.how-do-i-button .material-icons {
  font-size: 20px;
  animation: spin-sparkle 4s linear infinite;
}

.tour-start-button:hover,
.how-do-i-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.3);
}

@keyframes pulse-glow {
  from {
    box-shadow: 0 0 5px #2575fc, 0 0 10px #2575fc, 0 0 15px #6a11cb;
  }
  to {
    box-shadow: 0 0 10px #6a11cb, 0 0 20px #6a11cb, 0 0 25px #2575fc;
  }
}

@keyframes spin-sparkle {
  0% { transform: rotate(0deg) scale(1); opacity: 1; }
  25% { transform: rotate(90deg) scale(1.2); opacity: 0.7; }
  50% { transform: rotate(180deg) scale(1); opacity: 1; }
  75% { transform: rotate(270deg) scale(1.2); opacity: 0.7; }
  100% { transform: rotate(360deg) scale(1); opacity: 1; }
}

.tour-highlight {
  position: fixed;
  border-radius: 8px;
  box-shadow: 0 0 0 9999px rgba(0, 0, 0, 0.6), 0 0 15px rgba(255, 255, 255, 0.9), inset 0 0 10px rgba(255, 255, 255, 0.7);
  border: 2px solid #fff;
  z-index: 9999;
  pointer-events: none;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

.tour-tooltip {
  background-color: #2c3e50;
  color: #ecf0f1;
  padding: 15px 20px;
  border-radius: 8px;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.4);
  max-width: 350px;
  font-size: 1rem;
  line-height: 1.5;
  animation: tooltip-pop 0.3s ease-out;
  border: 1px solid rgba(255, 255, 255, 0.2);
}

@keyframes tooltip-pop {
  from { opacity: 0; transform: scale(0.9); }
  to { opacity: 1; transform: scale(1); }
}

.tour-tooltip .tour-content {
  margin-bottom: 15px;
}

.tour-tooltip .tour-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 0.9rem;
  color: #bdc3c7;
}

.tour-tooltip .tour-footer button {
  background: linear-gradient(45deg, #8e44ad, #3498db);
  color: white;
  border: none;
  padding: 8px 15px;
  border-radius: 5px;
  cursor: pointer;
  transition: all 0.2s;
  margin-left: 10px;
  font-weight: bold;
}

.tour-tooltip .tour-footer button:hover {
  transform: scale(1.05);
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
}

.tour-tooltip .tour-footer button.tour-close-button {
  background: transparent;
  color: #bdc3c7;
  padding: 0;
  box-shadow: none;
}

.tour-tooltip .tour-footer button.tour-close-button:hover {
  color: #fff;
  text-decoration: underline;
  transform: none;
}

/* Tooltip Arrow */
.tour-tooltip::after {
  content: '';
  position: absolute;
  border-width: 8px;
  border-style: solid;
}

.tour-tooltip.tour-tooltip-bottom::after {
  top: -16px;
  left: 30px;
  border-color: transparent transparent #2c3e50 transparent;
}

.tour-tooltip.tour-tooltip-top::after {
  bottom: -16px;
  left: 30px;
  border-color: #2c3e50 transparent transparent transparent;
}

.tour-tooltip.tour-tooltip-right::after {
  top: 20px;
  left: -16px;
  border-color: transparent #2c3e50 transparent transparent;
}

.tour-tooltip.tour-tooltip-left::after {
  top: 20px;
  right: -16px;
  border-color: transparent transparent transparent #2c3e50;
}

.tour-tooltip.tour-tooltip-center::after {
    display: none;
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

.tour-chapter-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.tour-chapter-modal-content {
  background-color: #1e1e1e;
  padding: 20px;
  border-radius: 5px;
  width: 500px;
  max-width: 90%;
}

.light-theme .tour-chapter-modal-content {
  background-color: #f8f9fa;
  border-color: #dee2e6;
}

.tour-chapter-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #333;
  padding-bottom: 10px;
  margin-bottom: 10px;
}

.light-theme .tour-chapter-modal-header {
  border-bottom-color: #dee2e6;
}

.tour-chapter-modal-header h2 {
  color: #ffffff;
}

.light-theme .tour-chapter-modal-header h2 {
  color: #212529;
}

.tour-chapter-list {
  list-style-type: none;
  padding: 0;
}

.tour-chapter-list li {
  display: flex;
  align-items: center;
  padding: 10px;
  border-bottom: 1px solid #333;
  cursor: pointer;
}

.light-theme .tour-chapter-list li {
  border-bottom-color: #dee2e6;
}

.tour-chapter-list li:hover {
  background-color: #2c2c2c;
}

.light-theme .tour-chapter-list li:hover {
  background-color: #e9ecef;
}

.tour-chapter-list li .material-icons {
  margin-right: 10px;
}

.tour-footer-buttons {
  display: flex;
  align-items: center;
}`, "",{"version":3,"sources":["webpack://./src/Tour.css"],"names":[],"mappings":"AAAA;;EAEE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,yCAAyC;EACzC,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,0CAA0C;AAC5C;AACA;EACE,eAAe;EACf,0CAA0C;AAC5C;;AAEA;;EAEE,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE;IACE,+DAA+D;EACjE;EACA;IACE,gEAAgE;EAClE;AACF;;AAEA;EACE,KAAK,gCAAgC,EAAE,UAAU,EAAE;EACnD,MAAM,mCAAmC,EAAE,YAAY,EAAE;EACzD,MAAM,kCAAkC,EAAE,UAAU,EAAE;EACtD,MAAM,oCAAoC,EAAE,YAAY,EAAE;EAC1D,OAAO,kCAAkC,EAAE,UAAU,EAAE;AACzD;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,uHAAuH;EACvH,sBAAsB;EACtB,aAAa;EACb,oBAAoB;EACpB,iDAAiD;AACnD;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,yCAAyC;EACzC,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,oCAAoC;EACpC,0CAA0C;AAC5C;;AAEA;EACE,OAAO,UAAU,EAAE,qBAAqB,EAAE;EAC1C,KAAK,UAAU,EAAE,mBAAmB,EAAE;AACxC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,oDAAoD;EACpD,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,yCAAyC;AAC3C;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,0BAA0B;EAC1B,eAAe;AACjB;;AAEA,kBAAkB;AAClB;EACE,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,UAAU;EACV,yDAAyD;AAC3D;;AAEA;EACE,aAAa;EACb,UAAU;EACV,yDAAyD;AAC3D;;AAEA;EACE,SAAS;EACT,WAAW;EACX,yDAAyD;AAC3D;;AAEA;EACE,SAAS;EACT,YAAY;EACZ,yDAAyD;AAC3D;;AAEA;IACI,aAAa;AACjB;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,6BAA6B;EAC7B,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB","sourcesContent":[".tour-start-button, \n.how-do-i-button{\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  color: white;\n  border: none;\n  padding: 10px 20px;\n  font-size: 16px;\n  cursor: pointer;\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);\n  transition: all 0.3s ease;\n  width:180px;\n}\n\n.tour-start-button .material-icons {\n  font-size: 20px;\n  animation: spin-sparkle 4s linear infinite;\n}\n.how-do-i-button .material-icons {\n  font-size: 20px;\n  animation: spin-sparkle 4s linear infinite;\n}\n\n.tour-start-button:hover,\n.how-do-i-button:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.3);\n}\n\n@keyframes pulse-glow {\n  from {\n    box-shadow: 0 0 5px #2575fc, 0 0 10px #2575fc, 0 0 15px #6a11cb;\n  }\n  to {\n    box-shadow: 0 0 10px #6a11cb, 0 0 20px #6a11cb, 0 0 25px #2575fc;\n  }\n}\n\n@keyframes spin-sparkle {\n  0% { transform: rotate(0deg) scale(1); opacity: 1; }\n  25% { transform: rotate(90deg) scale(1.2); opacity: 0.7; }\n  50% { transform: rotate(180deg) scale(1); opacity: 1; }\n  75% { transform: rotate(270deg) scale(1.2); opacity: 0.7; }\n  100% { transform: rotate(360deg) scale(1); opacity: 1; }\n}\n\n.tour-highlight {\n  position: fixed;\n  border-radius: 8px;\n  box-shadow: 0 0 0 9999px rgba(0, 0, 0, 0.6), 0 0 15px rgba(255, 255, 255, 0.9), inset 0 0 10px rgba(255, 255, 255, 0.7);\n  border: 2px solid #fff;\n  z-index: 9999;\n  pointer-events: none;\n  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.tour-tooltip {\n  background-color: #2c3e50;\n  color: #ecf0f1;\n  padding: 15px 20px;\n  border-radius: 8px;\n  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.4);\n  max-width: 350px;\n  font-size: 1rem;\n  line-height: 1.5;\n  animation: tooltip-pop 0.3s ease-out;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n}\n\n@keyframes tooltip-pop {\n  from { opacity: 0; transform: scale(0.9); }\n  to { opacity: 1; transform: scale(1); }\n}\n\n.tour-tooltip .tour-content {\n  margin-bottom: 15px;\n}\n\n.tour-tooltip .tour-footer {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  font-size: 0.9rem;\n  color: #bdc3c7;\n}\n\n.tour-tooltip .tour-footer button {\n  background: linear-gradient(45deg, #8e44ad, #3498db);\n  color: white;\n  border: none;\n  padding: 8px 15px;\n  border-radius: 5px;\n  cursor: pointer;\n  transition: all 0.2s;\n  margin-left: 10px;\n  font-weight: bold;\n}\n\n.tour-tooltip .tour-footer button:hover {\n  transform: scale(1.05);\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);\n}\n\n.tour-tooltip .tour-footer button.tour-close-button {\n  background: transparent;\n  color: #bdc3c7;\n  padding: 0;\n  box-shadow: none;\n}\n\n.tour-tooltip .tour-footer button.tour-close-button:hover {\n  color: #fff;\n  text-decoration: underline;\n  transform: none;\n}\n\n/* Tooltip Arrow */\n.tour-tooltip::after {\n  content: '';\n  position: absolute;\n  border-width: 8px;\n  border-style: solid;\n}\n\n.tour-tooltip.tour-tooltip-bottom::after {\n  top: -16px;\n  left: 30px;\n  border-color: transparent transparent #2c3e50 transparent;\n}\n\n.tour-tooltip.tour-tooltip-top::after {\n  bottom: -16px;\n  left: 30px;\n  border-color: #2c3e50 transparent transparent transparent;\n}\n\n.tour-tooltip.tour-tooltip-right::after {\n  top: 20px;\n  left: -16px;\n  border-color: transparent #2c3e50 transparent transparent;\n}\n\n.tour-tooltip.tour-tooltip-left::after {\n  top: 20px;\n  right: -16px;\n  border-color: transparent transparent transparent #2c3e50;\n}\n\n.tour-tooltip.tour-tooltip-center::after {\n    display: none;\n}\n\n@keyframes fadeIn {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n.tour-chapter-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.7);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n.tour-chapter-modal-content {\n  background-color: #1e1e1e;\n  padding: 20px;\n  border-radius: 5px;\n  width: 500px;\n  max-width: 90%;\n}\n\n.light-theme .tour-chapter-modal-content {\n  background-color: #f8f9fa;\n  border-color: #dee2e6;\n}\n\n.tour-chapter-modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  border-bottom: 1px solid #333;\n  padding-bottom: 10px;\n  margin-bottom: 10px;\n}\n\n.light-theme .tour-chapter-modal-header {\n  border-bottom-color: #dee2e6;\n}\n\n.tour-chapter-modal-header h2 {\n  color: #ffffff;\n}\n\n.light-theme .tour-chapter-modal-header h2 {\n  color: #212529;\n}\n\n.tour-chapter-list {\n  list-style-type: none;\n  padding: 0;\n}\n\n.tour-chapter-list li {\n  display: flex;\n  align-items: center;\n  padding: 10px;\n  border-bottom: 1px solid #333;\n  cursor: pointer;\n}\n\n.light-theme .tour-chapter-list li {\n  border-bottom-color: #dee2e6;\n}\n\n.tour-chapter-list li:hover {\n  background-color: #2c2c2c;\n}\n\n.light-theme .tour-chapter-list li:hover {\n  background-color: #e9ecef;\n}\n\n.tour-chapter-list li .material-icons {\n  margin-right: 10px;\n}\n\n.tour-footer-buttons {\n  display: flex;\n  align-items: center;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
